import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { DateTimeInput } from "../components/DateTimeInput";
import { EmployeePickerField, EmployeePickerModal } from "../../../common/selectComponents/EmployeePicker";

export function AddEditEmployeeMemoForm({
	isOpen,
	onClose,
	isEdit,
	memoTypeId, setMemoTypeId,
	memoTypes = [],
	dateFrom, dateTo, contentMemo, files,
	setDateFrom, setDateTo, setContentMemo, setFiles,
	selectedEmployeePersonalInformationId,
	setSelectedEmployeePersonalInformationId,
	editDataEmployeeMemo,         // ADDED - replaces employees[] lookup
	ccList = [],
	setCcList,
	isActive, setIsActive,        // KEPT - now properly used
	handleSubmitMemo
}) {
	const [errorState, setErrorState] = useState(false);
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [showCcPicker, setShowCcPicker] = useState(false);
	// MODIFIED - uses editDataEmployeeMemo directly instead of looking up from employees[]
	useEffect(() => {
		if (selectedEmployeePersonalInformationId && editDataEmployeeMemo?.employeePersonalInformationId === selectedEmployeePersonalInformationId) {
			setSelectedEmployee({
				id: editDataEmployeeMemo.employeePersonalInformationId,
				employeeId: editDataEmployeeMemo.employeeId,
				fullName: editDataEmployeeMemo.employeeFullName
			});
		} else if (!selectedEmployeePersonalInformationId) {
			setSelectedEmployee(null);
		}
	}, [selectedEmployeePersonalInformationId, editDataEmployeeMemo]);

	const submit = (e) => {
		if (!memoTypeId || !dateFrom || !dateTo || !contentMemo || !selectedEmployeePersonalInformationId) {
			setErrorState(true);
			return;
		}
		handleSubmitMemo(e);
		setErrorState(false);
	};

	const handleClose = () => {
		onClose();
		setErrorState(false);
	};

	const handleCcEmployeeSelected = (employee) => {
		if (
			!ccList.find(e => e.id === employee.id) &&
			employee.id !== selectedEmployeePersonalInformationId
		) {
			setCcList([...ccList, { id: employee.id, fullName: employee.fullName, employeeId: employee.employeeId }]);
		}
		setShowCcPicker(false);
	};

	const handleRemoveCc = (employeeId) => {
		setCcList(ccList.filter(e => e.id !== employeeId));
	};

	const handleBrowse = (e) => { setFiles(Array.from(e.target.files)); };

	const handleDrop = (e) => {
		e.preventDefault();
		setFiles(Array.from(e.dataTransfer.files));
		e.currentTarget.style.backgroundColor = "white";
	};

	const handleDragOver = (e) => { e.preventDefault(); e.currentTarget.style.backgroundColor = "#bdbdbd7d"; };
	const handleDragOut = (e) => { e.preventDefault(); e.currentTarget.style.backgroundColor = "white"; };

	const clearFiles = () => {
		setFiles([]);
		const input = document.getElementById('empMemoFileInput');
		if (input) input.value = '';
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>{isEdit ? "Edit Employee Memo" : "Add Employee Memo"}</h3>
							</div>
							<div className="popUp-close"><CloseIcon onClick={handleClose} /></div>
						</div>
						<div className="popUp-body">

							<EmployeePickerField
								label="Employee:"
								employeePersonalInformationId={selectedEmployeePersonalInformationId}
								displayValue={`${selectedEmployee?.fullName}`}
								onSelect={(emp) => {
									if (emp) {
										setSelectedEmployee(emp);
										setSelectedEmployeePersonalInformationId(emp.id);
									}
								}}
								error={!selectedEmployeePersonalInformationId && errorState}
								errorMessage="Please select an employee"
								allowClear={false}
							/>

							{/* Memo Type */}
							<div className="popUp-item info-item column">
								<div className="info-item-label">Memo Type</div>
								<div className="info-item-input">
									<select value={memoTypeId ?? ""} onChange={(e) => setMemoTypeId(e.target.value)} style={{ width: "100%" }}>
										<option value="">-- Select Memo Type --</option>
										{memoTypes.map((mt) => (<option key={mt.id} value={mt.id}>{mt.name}</option>))}
									</select>
								</div>
								<span style={{ visibility: !memoTypeId && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>
									Please select a memo type
								</span>
							</div>

							{/* Date From */}
							<div className="popUp-item info-item column">
								<div className="info-item-label">Date From</div>
								<div className="info-item-input"><DateTimeInput date={dateFrom} setDate={setDateFrom} /></div>
								<span style={{ visibility: !dateFrom && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
							</div>

							{/* Date To */}
							<div className="popUp-item info-item column">
								<div className="info-item-label">Date To</div>
								<div className="info-item-input"><DateTimeInput date={dateTo} setDate={setDateTo} /></div>
								<span style={{ visibility: !dateTo && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
							</div>

							{/* Content */}
							<div className="popUp-item info-item column">
								<div className="info-item-label">Content</div>
								<div className="info-item-input">
									<textarea
										id="emp-memo-content"
										style={{ width: "95%", minHeight: "100px", borderRadius: "3px", border: "1px solid #80808080", color: "rgb(104, 104, 104)" }}
										value={contentMemo}
										onChange={(e) => setContentMemo(e.target.value)}
									/>
								</div>
								<span style={{ visibility: !contentMemo && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
							</div>

							{/* Upload */}
							<div className="popUp-item info-item column">
								<div className="info-item-label">Upload</div>
								<div className="info-item-input">
									<label htmlFor="empMemoFileInput" className='browse'>Browse...</label>
									<input type="file" id="empMemoFileInput" onChange={handleBrowse} style={{ display: 'none' }} />
									{files && files.length > 0 ? (
										<div style={{ border: "1px solid #97979745", padding: "10px" }}>
											<span>Uploaded File:</span>
											<ul>
												{files.map((file, index) => (
													<img key={index} src={file instanceof File ? URL.createObjectURL(file) : `data:image/jpeg;base64,${file}`} alt="" style={{ width: "150px", height: "auto" }} />
												))}
											</ul>
											<div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
												<button className="cancel row" onClick={clearFiles} style={{ marginRight: "5px" }}>CLEAR</button>
											</div>
										</div>
									) : (
										<div onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragOut}
											style={{ border: '2px dashed #ccc', borderRadius: '5px', padding: '20px', marginTop: '10px', textAlign: 'center' }}>
											Drop files here
										</div>
									)}
								</div>
							</div>

							{/* CC Section */}
							<div className="popUp-item info-item column">
								<div className="info-item-label" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									<span>CC</span>
									<button
										type="button"
										onClick={() => setShowCcPicker(true)}
										style={{ fontSize: "11px", padding: "2px 10px", borderRadius: "4px", border: "1px solid #668fca", color: "#668fca", background: "white", cursor: "pointer" }}
									>
										+ Add
									</button>
								</div>
								<div className="info-item-input">
									{ccList.length === 0 ? (
										<span style={{ fontSize: "12px", color: "#aaa" }}>No CC recipients added.</span>
									) : (
										<div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
											{ccList.map((emp) => (
												<div key={emp.id} style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#eef2ff", border: "1px solid #c7d2fe", borderRadius: "999px", padding: "2px 10px", fontSize: "12px", color: "#3730a3" }}>
													<span>{emp.fullName}</span>
													<button type="button" onClick={() => handleRemoveCc(emp.id)}
														style={{ background: "none", border: "none", cursor: "pointer", color: "#818cf8", fontSize: "14px", lineHeight: 1, padding: "0 0 0 2px" }}>
														✕
													</button>
												</div>
											))}
										</div>
									)}
								</div>
							</div>

							{/* FIXED - isActive now correctly uses setIsActive */}
							<div className="popUp-item info-item row" style={{ alignItems: "center" }}>
								<div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
								<div className="info-item-input">
									<input
										type="checkbox"
										id="isActive-checkbox"
										className="checkbox"
										checked={isActive !== undefined ? isActive : true}
										onChange={(e) => setIsActive(e.target.checked)}
									/>
								</div>
							</div>

						</div>
						<div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
							<button className="save row" onClick={submit}>{isEdit ? "UPDATE" : "SAVE"}</button>
						</div>
					</div>
				)}
			</div>

			<EmployeePickerModal
				isOpen={showCcPicker}
				onClose={() => setShowCcPicker(false)}
				setData={handleCcEmployeeSelected}
			/>
		</>
	);
}